import styled from 'styled-components';


interface StyledIconWrapperStyleProps {
  backgroundColor: string;
}
export const StyledIconWrapper = styled.div<StyledIconWrapperStyleProps>`
  &&& {
    background-color: ${({ backgroundColor }) => `#${backgroundColor}`};
    width: 20px;
    min-width: 20px;
    height: 20px;
    border-radius: var(--cl-radius-0-5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
